<template>
    <div>
        <v-bottom-sheet
            v-model="showConsentModal"
            :scrim="false"
            location="bottom start"
            max-width="360"
            scroll-strategy="none"
            persistent
        >
            <v-card
                color="secondary"
            >
                <v-card-title
                    class="font-size-7"
                >
                    Your Privacy Choices
                </v-card-title>
                <v-card-text
                    class="py-0 font-size-8"
                >
                    <p
                        class="mt-0"
                    >
                        We use essential technologies to operate our website and optional technologies for analytics and marketing. Choose how you'd like us to use them.
                    </p>
                    <div>
                        Read more about our policy
                        <ul
                            class="mt-0 pl-1 list-inside"
                        >
                            <li
                                v-if="!props.hidePrivacyPolicyLink"
                            >
                                <NuxtLink
                                    class="text-primary"
                                    to="/privacy-policy"
                                >
                                    Privacy policy
                                </NuxtLink>
                            </li>
                            <li
                                v-if="!props.hideCookiePolicyLink"
                            >
                                <NuxtLink
                                    class="text-primary"
                                    to="/cookie-policy"
                                >
                                    Cookie policy
                                </NuxtLink>
                            </li>
                        </ul>
                    </div>
                </v-card-text>
                <v-card-actions
                    class="d-flex"
                >
                    <v-btn
                        color="primary"
                        variant="tonal"
                        size="small"
                        @click="onManageSettings"
                        slim
                    >
                        Manage Settings
                    </v-btn>
                    <v-btn
                        color="secondary"
                        variant="flat"
                        size="small"
                        @click="onAcceptAll"
                        slim
                    >
                        Accept All
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-bottom-sheet>

        <ResponsiveModal
            v-model="showCustomizeModal"
        >
            <template #default="{ onExit, openCount }">
                <PrivacySettingsCustomizeModal
                    v-model="settings"
                    @on-save="onSaveConsent"
                    @on-accept-all="onAcceptAll"
                    @on-exit="showCustomizeModal = false"
                ></PrivacySettingsCustomizeModal>
            </template>
        </ResponsiveModal>
    </div>
</template>

<script lang="ts" setup>
    import {
        usePrivacySettingsUtils
    } from '#x1-base/composables';

    const props = defineProps<{
        hidePrivacyPolicyLink?: boolean;
        hideCookiePolicyLink?: boolean;
    }>();

    const ResponsiveModal = defineAsyncComponent(() => import('#x1-base/components/ResponsiveModal/ResponsiveModal.vue'));
    const PrivacySettingsCustomizeModal = defineAsyncComponent(() => import('#x1-base/components/privacy/PrivacySettingsCustomizeModal/PrivacySettingsCustomizeModal.vue'));

    const {
        consentCookie,
        settings,
        saveConsent: persistConsent
    } = usePrivacySettingsUtils();


    const $config = useRuntimeConfig();
    const {
        isGA4Enabled,
        isMetaFbPixelEnabled
    } = $config.public;

    const showConsentModal = ref(false);
    const showCustomizeModal = ref(false);


    // const width = computed(() => step.value === 0 ? '320' : '420');

    function onManageSettings(): void {
        settings.e = true;
        settings.a = true;
        settings.m = true;

        showCustomizeModal.value = true;
        showConsentModal.value = false;
    }

    function open(): void {
        showCustomizeModal.value = false;
        showConsentModal.value = true;
    }

    function onAcceptAll() {
        settings.e = true;
        settings.a = true;
        settings.m = true;

        onSaveConsent();
    }

    function onSaveConsent(): void {
        persistConsent();
        showConsentModal.value = false;
        showCustomizeModal.value = false;
    }

    onMounted(() => {
        if (!consentCookie.value && (isGA4Enabled || isMetaFbPixelEnabled)) {
            showConsentModal.value = true;
        }
    });

    defineExpose({ open });
</script>

<style lang="scss"></style>
